// extracted by mini-css-extract-plugin
module.exports = {"invoiceImagePdfView":"InvoiceImage_invoiceImagePdfView_30XD1"};